import { render } from "./CreateTeam.vue?vue&type=template&id=eeda5ed6&scoped=true"
import script from "./CreateTeam.vue?vue&type=script&lang=js"
export * from "./CreateTeam.vue?vue&type=script&lang=js"

import "./CreateTeam.vue?vue&type=style&index=0&id=eeda5ed6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeda5ed6"]])

export default __exports__